import React, { useState } from 'react';
import classNames from 'classnames';
import ImageUploading from 'react-images-uploading';
import PropTypes from 'prop-types';

import UploaderIcon from 'assets/images/uploader.svg';
import LoadingIcon from 'assets/images/spinner.gif';
import { styledTheme } from 'globalStyles/theme';
import './styles.scss';

const ImageUploader = ({
  src,
  imageUploadType = 'photo',
  handleOnDrop,
  handleDelete,
  setImageError,
  setErrorTypes,
  imageUploadText = 'Drag your image here',
  showImageTypeRestrictionText = true,
  isLoading = false,
  sizeLimit = null,
}) => {
  const [isDraggingImage, setDraggingStatus] = useState(false);
  const [isImgInvalid, setImgValidation] = useState(false);

  const imageUploadClassName = (imageUploadType === 'photo') ? 'upload-photo'
    : imageUploadType === 'logo' ? 'upload-logo' : 'upload-shortcut';

  const isTypeAllowed = (type) => {
    return type === 'image/jpeg' || type === 'image/png';
  };

  const handleImagesUpdate = async (imageList, addUpdateIndex) => {
    if (!addUpdateIndex) return;
    const newImageIndex = addUpdateIndex[0];
    const newImg = imageList[newImageIndex];
    const imgType = newImg.file.type;
    if (!isTypeAllowed(imgType)) {
      setImageError(true);
      setImgValidation(true);
      return;
    }
    setImageError(false);
    setImgValidation(false);
    handleOnDrop(newImg.data_url, newImg.file.name);
  };

  return (
    <ImageUploading
      multiple={false}
      onChange={handleImagesUpdate}
      dataURLKey="data_url"
      acceptType={['jpg', 'jpeg', 'png']}
      maxFileSize={sizeLimit ? sizeLimit * 1024 * 1024 : sizeLimit}
      onError={(errors) => {
        if (setErrorTypes) setErrorTypes(errors);
        setImageError(true);
        setImgValidation(true);
      }}
    >
      {({ onImageUpload, isDragging, dragProps }) => (
        <div>
          <div
            className="submissions__upload"
            style={{
              backgroundColor: isDraggingImage
                ? styledTheme.dropBackground
                : styledTheme.lightGray,
              borderColor: isImgInvalid
                ? styledTheme.errorColor
                : styledTheme.lightGray,
            }}
            onDragEnter={(e) => {
              dragProps.onDragEnter(e);
              if (isDragging && !isDraggingImage) setDraggingStatus(true);
            }}
            onDragOver={(e) => {
              dragProps.onDragOver(e);
              setDraggingStatus(true);
            }}
            onDragLeave={(e) => {
              dragProps.onDragLeave(e);
              setDraggingStatus(false);
            }}
            onDrop={(e) => {
              dragProps.onDrop(e);
              setDraggingStatus(false);
            }}
          >
            {isLoading ? (
              <img
                src={LoadingIcon}
                alt="loading..."
                className="loader-icon"
              />
            ) : src ? (
              <div
                className={classNames(
                  imageUploadClassName,
                  'pb-1',
                )}
              >
                <img src={src}
                  alt="uploader Icon"
                  className="upload-icon"
                />
              </div>
            ) : (
              <img
                src={UploaderIcon}
                alt="uploader Icon"
                className="upload-icon pb-1"
              />
            )}
            <p className="form-description">
              {imageUploadText}, or{' '}
              <span className="upload-button"
                onClick={onImageUpload}
              >
                browse
              </span>
              .{showImageTypeRestrictionText && ' Jpeg or png images only.'}
            </p>
            {src && (
              <p className="form-description">
                <span className="upload-button"
                  onClick={handleDelete}
                >
                  Remove current image
                </span>
              </p>
            )}
          </div>
        </div>
      )}
    </ImageUploading>
  );
};

ImageUploader.propTypes = {
  src: PropTypes.any,
  handleOnDrop: PropTypes.func,
  handleDelete: PropTypes.func,
  imageUploadText: PropTypes.string,
  showImageTypeRestrictionText: PropTypes.bool,
  sizeLimit: PropTypes.number,
};

ImageUploader.defaultProps = {};

export default ImageUploader;
